import { BrowserBarcodeReader } from '@zxing/library';

const codeReader = new BrowserBarcodeReader();

export const scannerStatuses = {
  idle: 'idle',
  starting: 'starting',
  scanning: 'scanning',
  error: 'error',
};

let isScanning = false;
let notifyStatus = () => {};

const setStatus = (status) => notifyStatus(status);

// The camera is only really live (permission granted, frames arriving) once the video plays
const onVideoPlaying = () => {
  if (isScanning) setStatus(scannerStatuses.scanning);
};

const listenForVideoPlaying = () => {
  const video = document.getElementById('video');
  if (!video) return;
  video.removeEventListener('playing', onVideoPlaying);
  video.addEventListener('playing', onVideoPlaying);
};

// No deviceId: browsers hide device ids until camera permission is granted, so
// let ZXing request the rear camera via facingMode, which also triggers the prompt.
const waitForBarcode = (onScan) => {
  listenForVideoPlaying();
  codeReader.decodeOnceFromVideoDevice(undefined, 'video').then((result) => {
    if (!isScanning) return;
    onScan(result);
    waitForBarcode(onScan);
  }).catch((err) => {
    if (!isScanning) return;
    isScanning = false;
    setStatus(scannerStatuses.error);
    console.error('barcode scanner error', err);
  });
};

export const startBarcodeScanner = (onScan, onStatus = () => {}) => {
  notifyStatus = onStatus;
  if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
    setStatus(scannerStatuses.error);
    console.error('barcode scanner: camera not available (requires HTTPS)');
    return;
  }
  isScanning = true;
  setStatus(scannerStatuses.starting);
  waitForBarcode(onScan);
};

export const stopBarcodeScanner = () => {
  isScanning = false;
  codeReader.reset();
  setStatus(scannerStatuses.idle);
};
